// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SignUpToMotorwayPayBox_wrapper__mJEpv"};